import * as React from 'react';
import { Form, formValueSelector, reduxForm } from 'redux-form';
import { flow } from 'lodash';
import {Button, Row} from 'react-bootstrap';
import {
    IChannel,
    IPolicyApplication,
} from '../../../../data/api/models';
import FaChevronRight from 'react-icons/fa/chevron-right';
import {connect} from 'react-redux';
import {actions as quoteActions} from '../../../../services/quote/reducer';
import {bindActionCreators} from 'redux';
import {IStore} from '../../../../redux/IStore';
import DeclarationConsent from '../../components/DeclarationConsent';
import {scrollToFirstError} from '../../../../util/scrollToFirstError';

interface IPersonalDetailsProps {
    onBack: () => void;
    handleSubmit: () => void;
    product: any;
    channel: IChannel;
    isMobileView: boolean;
    renderDefinition(name: string): any;
}

class DeclarationB extends React.Component<IPersonalDetailsProps> {

    public render() {
        const { handleSubmit, onBack, product, channel, isMobileView, renderDefinition } = this.props;

        return (
            <div>
                <Form onSubmit={handleSubmit} autoComplete="off">
                    <div className="steps-container">
                        <div className="section-title">
                            {channel.key === 'camc-b2c' ? (
                                <h1>Your Health</h1>
                            ) : (
                                <h3>Your Health</h3>
                            )}
                        </div>
                        {channel.key === 'camc-b2c' ? (
                            <div className="section">
                                <p>
                                    This policy operates on an Accepted Conditions basis, which means you will be
                                    covered for pre-existing medical conditions if they are included in the list
                                     of “Accepted conditions” shown below, and the words in brackets apply to you.
                                </p>
                                <div className="info-card-primary">
                                    What is a pre-existing medical condition? {renderDefinition('pre_existing')}
                                </div>
                            </div>
                        ) : (
                            <div className="section">
                                <p>
                                    You will be covered for pre-existing medical conditions if they are included in the
                                    list of
                                    “Accepted conditions” shown below, and the words in brackets apply to you.
                                </p>
                                <div className="info-card-primary">
                                    What is a pre-existing medical condition? {renderDefinition('pre_existing')}
                                </div>
                            </div>
                        )}

                        <div className="section">
                            <Row>
                                <DeclarationConsent
                                    productTerms={product.metadata.product_terms}
                                    productDefinitions={product.metadata.definitions}
                                    channel={channel}
                                    isMobileView={isMobileView}
                                />
                                {channel.key === 'camc-b2c' && (
                                    <div className="info-card-primary"
                                         style={{marginTop: '40px', marginBottom: '20px'}}>
                                        If you are unable to meet the above criteria, please contact our UK based travel
                                        team to discuss an alternative product on 02392 419 888 our lines are open
                                        Monday to Friday 9am to 5pm.
                                    </div>
                                )}
                            </Row>
                        </div>
                        <div className="btn-bar margin-top">
                            <Button
                                bsStyle="primary"
                                type="submit"
                                className="pull-right btn-remove-border">
                                Continue to next step
                                <FaChevronRight/>
                            </Button>
                            <Button
                                type="button"
                                bsStyle="primary"
                                className="btn-back btn-remove-border" onClick={onBack}>
                                Back
                            </Button>
                        </div>
                    </div>
                </Form>
            </div>
        );
    }
}

let selector;
let previousValues;

export default flow([
    reduxForm({
        form: 'quote',
        destroyOnUnmount: false,
        forceUnregisterOnUnmount: true,
        onSubmitFail: () => {
            setTimeout(() => scrollToFirstError({ offset: 120 }), 0);
        },
        onChange: (
            values: IPolicyApplication,
            dispatch,
            props: IPersonalDetailsProps,
        ) => {
            if (! previousValues) {
                previousValues = values;
                return;
            }

            previousValues = values;
        },
    }),
    (component) => {
        selector = formValueSelector('quote');

        return component;
    },
    connect(
        (state: IStore) => {

            return {
                auth: state.auth,
                channel: state.branding.channel,
            };
        },
        (dispatch) => ({
            actions: {
                quote: bindActionCreators({ ...quoteActions }, dispatch),
            },
        }),
    ),
])(DeclarationB);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/DeclarationB/index.tsx